/*
 * File: index.js
 * Project: recnotes
 * Created: Thursday, September 9th 2021, 6:13:39 am
 * Last Modified: Thursday, September 9th 2021, 6:28:51 am
 * Copyright © 2021 AMDE Agência
 */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
